import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaHeart, FaRegHeart, FaArrowRight } from 'react-icons/fa';
import { cdnImage } from '../utils/img';
import { productPath } from '../utils/slug';
import './ProductCard.css';

const ProductCard = ({
  product,
  compact,
  onAddToCart,
  selectedSize,
  selectedColor,
  onSizeSelect,
  onColorSelect,
  onQuickView,
}) => {
  const [wishlisted, setWishlisted] = useState(false);
  const [imgIndex, setImgIndex] = useState(0);
  const productUrl = productPath(product);

  const allImages = product.images?.length > 0
    ? product.images
    : product.imageUrl
      ? [product.imageUrl]
      : product.image_url
        ? [product.image_url]
        : [];

  const currentSrc = allImages[imgIndex] || null;

  const hasDiscount = !!(product.discountPrice && product.discountPrice < product.price);
  const discountPrice = product.discountPrice || product.discount_price;
  const displayPrice = hasDiscount ? discountPrice : product.price;
  const discountPct = hasDiscount
    ? Math.round((1 - discountPrice / product.price) * 100)
    : 0;
  const fmt = (p) => `KSh ${Number(p || 0).toLocaleString()}`;
  const inStock = product.stock !== 0 && product.inStock !== false;

  // Always render a real <a href="/product/…"> so crawlers can discover product
  // pages and shoppers can open them in a new tab. When a quick-view handler is
  // supplied, intercept the left-click to open the modal instead — the href
  // stays intact for crawlers, middle-click and SEO.
  const handleClick = (e) => {
    if (onQuickView) {
      e.preventDefault();
      onQuickView();
    }
  };

  return (
    <Link
      className={`pcard${compact ? ' pcard--compact' : ''}`}
      to={productUrl}
      onClick={handleClick}
    >
      <div className="pcard-wrap">
        {currentSrc ? (
          <img
            src={cdnImage(currentSrc, 500)}
            alt={product.name}
            className="pcard-photo"
            onError={() => {
              if (imgIndex < allImages.length - 1) setImgIndex(imgIndex + 1);
            }}
            loading="lazy"
          />
        ) : (
          <div className="pcard-photo pcard-no-img" aria-label={product.name} />
        )}

        {!compact && <div className="pcard-grad" />}

        {/* Top-left badge */}
        {hasDiscount && (
          <span className="pcard-badge pcard-badge--sale">-{discountPct}%</span>
        )}
        {!hasDiscount && product.isNew && (
          <span className="pcard-badge pcard-badge--new">New</span>
        )}
        {!inStock && (
          <span className="pcard-badge pcard-badge--sold">Sold Out</span>
        )}

        {/* Wishlist */}
        <button
          className={`pcard-wish${wishlisted ? ' is-wished' : ''}`}
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); setWishlisted(!wishlisted); }}
          aria-label={wishlisted ? 'Remove from wishlist' : 'Add to wishlist'}
        >
          {wishlisted ? <FaHeart /> : <FaRegHeart />}
        </button>

        {/* Bottom info */}
        <div className="pcard-info">
          {product.brand && <span className="pcard-brand">{product.brand}</span>}
          <h3 className="pcard-title">{product.name}</h3>
          <div className="pcard-price-row">
            <span className="pcard-price">{fmt(displayPrice)}</span>
            {hasDiscount && <span className="pcard-original">{fmt(product.price)}</span>}
          </div>
          <span className="pcard-cta">View Details <FaArrowRight /></span>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
